/* eslint-disable no-magic-numbers */
import React, { useMemo } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { LEAD_FORM, STEP_NAMES } from "../../../constants/app-constants";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { withRouter } from "react-router";
import { FUNNEL_CONFIG } from "../../../utils/funnel/steps.desktop";
import LazyImage from "../../shared/lazy-image";
import { sendCustomGaEvents } from "../../../tracking";
import { clickedBrandIcon } from "./tracking";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";

const type = LEAD_FORM.DEFAULT_REVAMP;
const formConfig = FUNNEL_CONFIG[type];

const LuxuryCarsBrands = ({
    elite: brands = [],
    setDataConnect,
    setStepConnect,
    title,
    brandsPerRow,
    brandsToShow,
    showAllBrands = false
}) => {
    const { tokens } = useTokens();
    const brandList = useMemo(() => brands.slice(0, brandsToShow), [brands, brandsToShow]);

    const setData = async (data) => {
        setDataConnect(data, formConfig);
        await yieldToMain();
        sendCustomGaEvents({
            ...clickedBrandIcon,
            eventLabel: data?.data?.displayText
        });
    };

    const nextStep = (stepName) => {
        window.scrollTo(0, 0);
        setStepConnect({ currentStep: stepName, tabs: formConfig.tabs });
    };

    const handleBrandClick = (selectedBrand) => () => {
        setData({ type: STEP_NAMES.Brand, data: selectedBrand });
        nextStep(STEP_NAMES.Year);
    };

    if (!brands?.length) {
        return null;
    }
    const visibleBrands = showAllBrands ? brands : brandList;

    return (
        <div>
            <Text
                align="center"
                as="h2"
                fontWeight="medium"
                size="500"
                transform="none"
                color={tokens.text_default_text_primary}
            >
                {title}
            </Text>
            <div styleName={"styles.carCardWrapper"}>
                {visibleBrands.map(el => (
                    <div
                        onClick={handleBrandClick({ displayText: el.make_display, id: el.make_id })}
                        key={el.make_id}
                        styleName={"styles.carLogoWrapper"}
                        style={{ flex: `0 0 ${100 / brandsPerRow}%` }}>
                        <div styleName={"styles.carLogo"}>
                            <LazyImage src={el.logo} alt={el.make_display} />
                        </div>
                        <Text
                            align="left"
                            as="p"
                            fontWeight="regular"
                            size="200"
                            transform="none"
                            color={tokens.text_default_text_primary}
                        >
                            {el.displayName}
                        </Text>
                    </div>
                ))}
            </div>
        </div>
    );
};

LuxuryCarsBrands.propTypes = {
    elite: PropTypes.array,
    setDataConnect: PropTypes.func,
    setStepConnect: PropTypes.func,
    title: PropTypes.string,
    brandsPerRow: PropTypes.number,
    brandsToShow: PropTypes.number,
    showAllBrands: PropTypes.bool
};

export default withRouter(LuxuryCarsBrands);
